import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../axiosConfig';
import { endpoints } from '../../utils/constants';
import { sendLogger } from '../../utils/loggerUtils';
import { LogLevels } from '../../utils/enums';

let savingMetricPromise = null;

export const saveMetric = createAsyncThunk('metrics/saveMetric', async (body, { dispatch }) => {
  savingMetricPromise = axios.post(endpoints.SAVE_METRICS, body, { headers });
  try {
    const response = await savingMetricPromise;
    return response.data;
  } catch (error) {
    const errMsg = 'Error saving metrics: ' + error;
    sendLogger(dispatch, errMsg, LogLevels.ERROR);
    throw error;
  }
});

const metricsSlice = createSlice({
  name: 'metrics',
  initialState: {
    data: [],
    loading: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(saveMetric.pending, (state) => {
        state.loading = 'loading';
      })
      .addCase(saveMetric.fulfilled, (state, action) => {
        state.loading = 'succeeded';
        state.data = action.payload;
      })
      .addCase(saveMetric.rejected, (state, action) => {
        state.loading = 'failed';
        state.error = action.error.message;
      });
  },
});

export default metricsSlice.reducer;